__turbopack_context__.v({
  "buttonsWrapper": "AO0j3G_buttonsWrapper",
  "categoryTitle": "AO0j3G_categoryTitle",
  "invalidProduct": "AO0j3G_invalidProduct",
  "invalidProductData": "AO0j3G_invalidProductData",
  "invalidProductDescription": "AO0j3G_invalidProductDescription",
  "invalidProductTitle": "AO0j3G_invalidProductTitle",
  "invalidProductsTitle": "AO0j3G_invalidProductsTitle",
  "invalidProductsWrapper": "AO0j3G_invalidProductsWrapper",
  "listWrapper": "AO0j3G_listWrapper",
  "productsCount": "AO0j3G_productsCount",
  "productsList": "AO0j3G_productsList",
});
